import { get } from 'lodash'
import requestWithRetry from 'civic-champs-shared/api/requestWithRetry'

import fetchFeaturesForOrg from 'core/feature/fetchFeaturesForOrg'
import { getFeaturesForUser, getFeaturesForUserFailed, getFeaturesForUserSucceeded } from 'core/feature/actions'
import { authBootstrapFailed, authInitialized } from './actions'
import { readManagedOrgOverride } from './managedOrgOverride'
import resolveCurrentOrganization from './resolveCurrentOrganization'
import { reportAuthInitFailed, reportAuthNoUserSession } from './authDiagnostics'

export async function runAuthBootstrap(dispatch, user, { reason } = {}) {
  const orgId = get(user, 'permissions.managedOrganization.id')

  if (!user) {
    reportAuthNoUserSession(reason || 'bootstrap')
    return
  }

  const featuresOrgId = readManagedOrgOverride(get(user, 'cognitoSub')) ?? orgId ?? null

  try {
    const [organization, profile, featureSet] = await Promise.all([
      resolveCurrentOrganization(user, orgId),
      requestWithRetry({ url: `/my-profile` }),
      fetchFeaturesForOrg(featuresOrgId),
    ])

    dispatch(authInitialized(user, organization, profile))

    const resolvedOrgId = get(organization, 'id') ?? null
    if (resolvedOrgId !== featuresOrgId) {
      dispatch(getFeaturesForUser(user, resolvedOrgId))
    } else if (featureSet.error) {
      dispatch(getFeaturesForUserFailed(user, featureSet.error))
    } else {
      dispatch(getFeaturesForUserSucceeded(user, featureSet.features))
    }
  } catch (e) {
    reportAuthInitFailed(`The organization id:${orgId} could not be fetched!`, 'bootstrap')
    dispatch(authBootstrapFailed(`The organization id:${orgId} could not be fetched!`, e))
  }
}
